import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentWrapper } from '../../components/ContentWrapper';
import {
  getCountdownData,
  isContestEnded,
  isContestStarted,
  isTutorialRegistrationEnded,
  isTutorialRegistrationStarted,
  isRegistrationStarted,
  isRegistrationEnded,
} from '../../utils';
import { Countdown } from '../../components';
import { CountdownData } from '../../types';
import { AppRoutes } from '../../types/routes';

export const Home = () => {
  const navigate = useNavigate();
  const [countdownData, setCountdownData] = useState<CountdownData>(getCountdownData());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdownData(getCountdownData());

      if (isContestStarted() && !isContestEnded()) {
        navigate(AppRoutes.Quiz);
        clearInterval(intervalId);
        return;
      }

      if (isContestEnded()) {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [navigate]);

  useEffect(() => {
    if (isTutorialRegistrationStarted() && !isTutorialRegistrationEnded()) {
      navigate(AppRoutes.Tutorial);
    }

    if (isContestStarted() && !isContestEnded()) {
      navigate(AppRoutes.Quiz);
    }
  }, [navigate]);

  return (
    <ContentWrapper>
      <Countdown {...countdownData} />
      {isRegistrationStarted() && !isRegistrationEnded() && (
        <div className="flex flex-row items-center justify-center text-center">
          <button
            type="button"
            onClick={() => navigate(AppRoutes.Register)}
            className="hidden md:inline-flex primary-button"
          >
            Creează cont
          </button>
        </div>
      )}
      {isContestStarted() && !isContestEnded() && (
        <div className="flex flex-col justify-center gap-3 text-center">
          <div className="text-xl text-slate-500">
            Concursul este în desfășurare!{' '}
            <a href={AppRoutes.Quiz} className="text-primary underline">
              Mergi la concurs
            </a>
          </div>
        </div>
      )}
    </ContentWrapper>
  );
};
